import React from "react";
import { Tag } from "antd";

const formatDate = (val) => (val ? new Date(val).toLocaleDateString() : "-");

export const getBundleCourseColumns = (expandedRowKey) => [
  {
    title: "Title",
    dataIndex: "courseTitle",
    render: (text, record) => (
      <>
        <span className="enrollment-title font-normal text-[#262626]">
          {text}
        </span>
        <div className="enrollment-meta text-[12px] text-gray-500 mt-1">
          {record.enrollmentSource && <div>Enrollment: {record.enrollmentSource}</div>}
        </div>
      </>
    ),
  },
  {
    title: "Progress",
    dataIndex: "courseCompletionPercentage",
    render: (val) => {
      const num = Number(val || 0);
      return `${num % 1 === 0 ? num : num.toFixed(2)}%`;
    },
  },
  {
    title: <div style={{ textAlign: "left" }}>Status</div>,
    dataIndex: "status",
    render: (val) => {
      const statusStyles = {
        "In Progress": {
          color: "rgba(2, 93, 222, 1)",
          background: "rgba(232, 241, 255, 1)",
          borderColor: "rgba(139, 187, 255, 1)",
        },
        Completed: {
          color: "rgba(8, 138, 21, 1)",
          background: "rgba(238, 255, 240, 1)",
          borderColor: "rgba(149, 222, 157, 1)",
        },
        "Not Started": {
          color: "rgba(200, 0, 0, 1)",
          background: "rgba(255, 238, 238, 1)",
          borderColor: "rgba(255, 170, 170, 1)",
        },
        default: {
          color: "gray",
          background: "rgba(240, 240, 240, 1)",
          borderColor: "rgba(200, 200, 200, 1)",
        },
      };

      const style = statusStyles[val] || statusStyles.default;

      return (
        <Tag
          style={{
            padding: "10px 16px",
            borderRadius: "10px",
            border: `1px solid ${style.borderColor}`,
            color: style.color,
            backgroundColor: style.background,
          }}
        >
          {val}
        </Tag>
      );
    },
  },
  {
    title: "Adherence",
    dataIndex: "adherence",
    align: "center",
  },
  {
    title: "Active",
    dataIndex: "isEnrollmentActive",
    render: (val) => (val ? "Yes" : "No"),
  },
  {
    title: "Acknowledged",
    align: "center",
    dataIndex: "allContentAcknowledged",
    render: (val) => {
      if (val === true) return "Yes";
      if (val === false) return "No";
      return "N/A"; 
    },
  },
  {
    title: "Quiz Score",
    width: "8%",
    render: (_, record) => {
      const score = record.quiz?.highestScore;
      if (score == null) return "NA";
      const num = Number(score);
      return `${num % 1 === 0 ? num : num.toFixed(2)}%`;
    },
  },

]
export const getCourseColumns = (expandedRowKey) => [
  {
    title: "Title",
    render: (_, record) => (
      <>
        <span className="enrollment-title">{record.displayTitle}</span>
        <div className="enrollment-meta">
          {record.enrollmentSource && <div>Source: {record.enrollmentSource}</div>}
          {record.groupName && record.groupName !== "null" && (
            <div>Group: {record.groupName}</div>
          )}
        </div>
      </>
    ),
  },
  {
    title: "Type",
    width: "10%",
    render: (_, record) => record.type === "BUNDLE" ? "Curriculum" : "Course",
  },
  {
    title: "Assigned At",
    dataIndex: "assignedAt",
    width: "10%",
    render: formatDate,
  },
  {
    title: "Deadline",
    dataIndex: "deadline",
    width: "10%",
    render: formatDate,
  },
  {
    title: "Progress",
    width: "8%",
    dataIndex: "courseCompletionPercentage",
    render: (val) => {
      const num = Number(val || 0);
      return `${num % 1 === 0 ? num : num.toFixed(2)}%`;
    },
  },
  {
    title: <div style={{ textAlign: "center" }}>Status</div>,
    width: "10%",
    dataIndex: "status",
    render: (val) => {
      const statusStyles = {
        "In Progress": { color: "rgba(2, 93, 222, 1)", background: "rgba(232, 241, 255, 1)", borderColor: "rgba(139, 187, 255, 1)" },
        Completed: { color: "rgba(8, 138, 21, 1)", background: "rgba(238, 255, 240, 1)", borderColor: "rgba(149, 222, 157, 1)" },
        "Not Started": { color: "rgba(200, 0, 0, 1)", background: "rgba(255, 238, 238, 1)", borderColor: "rgba(255, 170, 170, 1)" },
        default: { color: "gray", background: "rgba(240, 240, 240, 1)", borderColor: "rgba(200, 200, 200, 1)" },
      };
      const style = statusStyles[val] || statusStyles.default;
      return (
        <Tag style={{ padding: "10px 16px", borderRadius: "10px", border: `1px solid ${style.borderColor}`, color: style.color, backgroundColor: style.background }}>
          {val}
        </Tag>
      );
    },
  },
  {
    title: "Adherence",
    dataIndex: "adherence", 
    width: "10%",
  },
  {
    title: "Active",
    width: "8%",
    render: (_, record) => (record.isEnrollmentActive ? "Yes" : "No"),
  },
  {
    title: "Acknowledged",
    width: "10%",
    render: (_, record) => {
      const val = record.type === "BUNDLE"
        ? record.allCourseContentAcknowledged
        : record.allContentAcknowledged;
      if (val === true) return "Yes";
      if (val === false) return "No";
      return "N/A";
    },
  },
  {
    title: "Quiz Score",
    width: "8%",
    render: (_, record) => {
      if (record.type === "BUNDLE") return "N/A";
      const score = record.quiz?.highestScore;
      if (score == null) return "NA";
      const num = Number(score);
      return `${num % 1 === 0 ? num : num.toFixed(2)}%`;
    },
  },
];

export const getBundleColumns = () => [
  {
    title: "Curriculum Title",
    dataIndex: "bundleName",
    align: "left",
  },
  {
    title: "Assigned At",
    dataIndex: "assignedAt",
    render: formatDate,
  },
  {
    title: "Deadline",
    dataIndex: "deadline",
    render: formatDate,
  },
  {
    title: "Progress",
    dataIndex: "avgProgress",
    render: (val) => {
      const num = Number(val || 0);
      return `${num % 1 === 0 ? num : num.toFixed(2)}%`;
    },
  },
  {
    title: <div style={{ textAlign: "left" }}>Status</div>,
    dataIndex: "bundleStatus",
    render: (val) => {
      const statusStyles = {
        "In Progress": {
          color: "rgba(2, 93, 222, 1)",
          background: "rgba(232, 241, 255, 1)",
          borderColor: "rgba(139, 187, 255, 1)",
        },
        Completed: {
          color: "rgba(8, 138, 21, 1)",
          background: "rgba(238, 255, 240, 1)",
          borderColor: "rgba(149, 222, 157, 1)",
        },
        "Not Started": {
          color: "rgba(200, 0, 0, 1)",
          background: "rgba(255, 238, 238, 1)",
          borderColor: "rgba(255, 170, 170, 1)",
        },
        default: {
          color: "gray",
          background: "rgba(240, 240, 240, 1)",
          borderColor: "rgba(200, 200, 200, 1)",
        },
      };

      const style = statusStyles[val] || statusStyles.default;

      return (
        <Tag
          style={{
            padding: "10px 16px",
            borderRadius: "10px",
            border: `1px solid ${style.borderColor}`,
            color: style.color,
            backgroundColor: style.background,
          }}
        >
          {val}
        </Tag>
      );
    },
  },
  {
    title: "Adherence",
    dataIndex: "worstAdherence",
  },
  {
    title: "Acknowledged",
    dataIndex: "allCourseContentAcknowledged",
  },
];

export const contentColumns = [
  {
    title: "Title",
    dataIndex: "contentTitle",
    width: "10%",
  },
  {
    title: "Type",
    dataIndex: "contentType",
    width: "10%",
  },
  {
    title: "Completion",
    dataIndex: "contentCompletionPercentage",
    width: "10%",
    render: (val) => {
      const num = Number(val || 0);
      return `${num % 1 === 0 ? num : num.toFixed(2)}%`;
    },
  },
  {
    title: "Acknowledged",
    dataIndex: "contentAcknowledgement",
    width: "3%",
    render: (val) => (val ? "Yes" : "No"),
  },
];